(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    const heroSearch = root.querySelector('.fr-search-home__search input[type="search"]');
    root.querySelectorAll('[data-fr-focus-search]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!heroSearch) return;
        heroSearch.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => heroSearch.focus({ preventScroll: true }), 500);
      });
    });

    const rail = root.querySelector('[data-fr-product-rail]');
    if (rail) {
      root.querySelectorAll('[data-fr-rail-button]').forEach((button) => {
        button.addEventListener('click', () => {
          const card = rail.querySelector('.fr-search-home__product-card');
          const distance = card ? card.getBoundingClientRect().width + 18 : rail.clientWidth * 0.8;
          rail.scrollBy({ left: button.dataset.frRailButton === 'next' ? distance : -distance, behavior: 'smooth' });
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-fr-search-home]').forEach(init);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initAll) : initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
